var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.item.isLinkProduct == -1
        ? _c(
            "div",
            [
              _c("hotel-resource-left", {
                attrs: { productObj: _vm.item, showTag: false },
                on: { exclusiveAddYsP: _vm.exclusiveAddYsP },
              }),
              _vm.item.isOpen
                ? _c(
                    "div",
                    { staticClass: "contentContainer" },
                    [
                      _vm._l(_vm.item.customList, function (item1, index) {
                        return _c(
                          "div",
                          {
                            key: "detailResponses" + index,
                            staticClass: "boxContainer",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "boxContainer-title",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    item1.isOpen = !item1.isOpen
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item1.budgetType == ""
                                        ? "点击后方下拉查看更多价格 "
                                        : item1.budgetType
                                    )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "1.17rem",
                                      display: "flex",
                                      "justify-content": "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          width: "0.6rem",
                                          "text-align": "end",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item1.price) +
                                            _vm._s(item1.currency) +
                                            "起"
                                        ),
                                      ]
                                    ),
                                    _c("span", [
                                      _c("i", {
                                        class: item1.isOpen
                                          ? "el-icon-caret-top"
                                          : "el-icon-caret-bottom",
                                        staticStyle: { "font-size": "0.2rem" },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item1.isOpen,
                                    expression: "item1.isOpen",
                                  },
                                ],
                              },
                              _vm._l(item1.children, function (item2, index1) {
                                return _c("div", { key: index1 }, [
                                  _c(
                                    "div",
                                    { staticClass: "boxContainer-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          staticStyle: {
                                            display: "flex",
                                            "margin-left": "0.13rem",
                                            width: "20%",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.stockDetail(item2)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item2.productNameCn)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: item2.productDesc,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "sp1 specialone" },
                                            [
                                              item2.stockDesc &&
                                              item2.stockDesc != ""
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item2.stockDesc) +
                                                        "  "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item2.productDesc) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            width: "300",
                                            trigger: "hover",
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _c("span", [
                                              _vm._v(
                                                "同业价:" +
                                                  _vm._s(
                                                    item2.priceList[0].toBPrice
                                                  ) +
                                                  _vm._s(
                                                    item2.priceList[0].currency
                                                  ) +
                                                  "  "
                                              ),
                                            ]),
                                            _c("span", [
                                              _vm._v(
                                                "直客价:" +
                                                  _vm._s(
                                                    item2.priceList[0].toCPrice
                                                  ) +
                                                  _vm._s(
                                                    item2.priceList[0].currency
                                                  ) +
                                                  "  "
                                              ),
                                            ]),
                                            _c("span", [
                                              _vm._v(
                                                "门市价:" +
                                                  _vm._s(
                                                    item2.priceList[0]
                                                      .marketPrice
                                                  ) +
                                                  _vm._s(
                                                    item2.priceList[0].currency
                                                  )
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item price",
                                              attrs: { slot: "reference" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changePrice(
                                                    _vm.item,
                                                    item1,
                                                    item2
                                                  )
                                                },
                                              },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item2.priceList[0].price
                                                  ) +
                                                  _vm._s(
                                                    item2.priceList[0].currency
                                                  ) +
                                                  _vm._s(
                                                    item2.priceList[0].useTime
                                                  ) +
                                                  "/" +
                                                  _vm._s(
                                                    item2.priceList[0]
                                                      .priceCompany
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          staticStyle: {
                                            "margin-right": "0.1rem",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "0.6rem" },
                                            attrs: { size: "mini" },
                                            model: {
                                              value: item2.checkNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item2,
                                                  "checkNumber",
                                                  $$v
                                                )
                                              },
                                              expression: "item2.checkNumber",
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item2.priceList[0]
                                                    .priceCompany
                                                )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "item add" }, [
                                        _c("span", { staticClass: "qiang" }, [
                                          _vm._v("抢"),
                                        ]),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus-outline",
                                          on: {
                                            click: function ($event) {
                                              return _vm.checkHotelYsTime(
                                                _vm.item,
                                                item2
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "text-align": "right",
                            "font-size": "0.25rem",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-caret-top",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                _vm.item.isOpen = false
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "zhafeiDiv" }, [
              _c("div", [
                _c("span", { staticClass: "incidentalCard-span" }, [
                  _vm._v("杂费"),
                ]),
                _c("b", { staticClass: "incidentalCard-title" }, [
                  _vm._v(_vm._s(_vm.item.nameCn)),
                ]),
              ]),
              _c("div", { staticClass: "showCard-tag-div" }, [
                _c("div", { staticClass: "showCard-tag" }, [
                  _c("div", [
                    _c("i", {
                      class: _vm.item.isOpen
                        ? "el-icon-caret-top"
                        : "el-icon-caret-bottom",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.openclick(_vm.item)
                        },
                      },
                    }),
                  ]),
                  _c("div", [
                    _c("b", [_vm._v(_vm._s(_vm.item.price))]),
                    _c("b", { staticStyle: { "font-size": "0.12rem" } }, [
                      _vm._v(_vm._s(_vm.item.currency)),
                    ]),
                    _c("label", [_vm._v("起")]),
                  ]),
                ]),
              ]),
            ]),
            _vm.item.isOpen
              ? _c(
                  "div",
                  { staticClass: "contentContainer" },
                  [
                    _vm._l(_vm.item.customList, function (item1, index) {
                      return _c(
                        "div",
                        {
                          key: "detailResponses" + index,
                          staticClass: "boxContainer",
                        },
                        _vm._l(item1.children, function (item2, index1) {
                          return _c("div", { key: index1 }, [
                            _c(
                              "div",
                              { staticClass: "boxContainer-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "item",
                                    staticStyle: {
                                      display: "flex",
                                      "margin-left": "0.13rem",
                                      width: "20%",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.stockDetail(item2)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item2.productNameCn))]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: item2.productDesc,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "sp1 specialone" },
                                      [
                                        item2.stockDesc && item2.stockDesc != ""
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(item2.stockDesc) + "  "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          " " + _vm._s(item2.productDesc) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-popover",
                                  { attrs: { width: "300", trigger: "hover" } },
                                  [
                                    _c("p", [
                                      _c("span", [
                                        _vm._v(
                                          "同业价:" +
                                            _vm._s(
                                              item2.priceList[0].toBPrice
                                            ) +
                                            "  "
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "直客价:" +
                                            _vm._s(
                                              item2.priceList[0].toCPrice
                                            ) +
                                            "  "
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "门市价:" +
                                            _vm._s(
                                              item2.priceList[0].marketPrice
                                            )
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item price",
                                        attrs: { slot: "reference" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePrice(
                                              _vm.item,
                                              item1,
                                              item2
                                            )
                                          },
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item2.priceList[0].price) +
                                            _vm._s(
                                              item2.priceList[0].currency
                                            ) +
                                            _vm._s(item2.priceList[0].useTime) +
                                            "/" +
                                            _vm._s(
                                              item2.priceList[0].priceCompany
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item",
                                    staticStyle: {
                                      "margin-right": "0.1rem",
                                      "text-align": "right",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "0.6rem" },
                                      attrs: { size: "mini" },
                                      model: {
                                        value: item2.checkNumber,
                                        callback: function ($$v) {
                                          _vm.$set(item2, "checkNumber", $$v)
                                        },
                                        expression: "item2.checkNumber",
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item2.priceList[0].priceCompany
                                          )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "item add" }, [
                                  _c("span", { staticClass: "qiang" }, [
                                    _vm._v("抢"),
                                  ]),
                                  _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.checkHotelYsTime(
                                          _vm.item,
                                          item2
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                          ])
                        }),
                        0
                      )
                    }),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "font-size": "0.25rem",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-caret-top",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.item.isOpen = false
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]),
      _vm.item.state === 0 || _vm.item.isLinkProduct == 0
        ? _c("add-hotel-product-dialog", { ref: "addProductDialog" })
        : _vm.item.state === 4 || _vm.item.isLinkProduct == 4
        ? _c("add-meal-product-dialog", { ref: "addProductDialog" })
        : _c("add-traffic-product-dialog", { ref: "addProductDialog" }),
      _c("create-product-dialog", {
        ref: "createProduct",
        attrs: { keyStr: _vm.keyStr },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "40%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [_c("stock-detail", { attrs: { stockDetailObj: _vm.stockDetailObj } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }